import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { ArrowRight, FileCheck2 } from 'lucide-react';

export default function Permitting() {
  const { t } = useLang();
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="permitting" className="bg-[#0B0D0F] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 bg-[#12151A] rounded-lg border border-white/8 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded bg-[#D4AF37]/20 flex items-center justify-center"><FileCheck2 className="w-6 h-6 text-[#D4AF37]" /></div>
              <div><h3 className="text-white font-bold font-outfit">{t.permit.heading}</h3><p className="text-slate-400 text-sm">Miami-Dade County</p></div>
            </div>
            <div className="space-y-3">
              {t.permit.items.map(item => (<div key={item} className="flex items-center gap-3 text-slate-300 text-sm"><div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] flex-shrink-0" />{item}</div>))}
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.permit.label}</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 mb-6 font-outfit">{t.permit.heading}</h2>
            <p className="text-slate-300 leading-relaxed mb-6">{t.permit.desc}</p>
            <p className="text-slate-400 text-sm mb-8 italic">{t.permit.disclaimer}</p>
            <button onClick={() => scrollTo('#estimate')} data-testid="permitting-cta"
              className="group inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-bold px-8 py-4 rounded transition-all">
              {t.permit.cta}<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
